import type { StarterDashboardRootPageDataQuery } from '../rootPageData.graphql';

import { getPetitionDaysAfterPublish } from './getPetitionDaysAfterPublish';
import { getPetitionShareVisuals } from './getPetitionShareVisuals';
import { getPetitionStrengthScore } from './getPetitionStrengthScore';

export function getPetitionMetadata(petition: NonNullable<StarterDashboardRootPageDataQuery['petition']>) {
	return {
		daysAfterPublish: getPetitionDaysAfterPublish(petition),
		score: getPetitionStrengthScore(petition),
		shareVisuals: getPetitionShareVisuals(petition),
	};
}
